// extracted by mini-css-extract-plugin
module.exports = {"column":"PostColumn_column__1N_WU"};